import { render, staticRenderFns } from "./VSubOrderExpress.vue?vue&type=template&id=88d58176&scoped=true"
import script from "./VSubOrderExpress.vue?vue&type=script&lang=ts"
export * from "./VSubOrderExpress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d58176",
  null
  
)

export default component.exports